
export const SET_DRAWER_STATE = "set_drawer_state";

export const setDrawerState = (isOpen) => {
    return {
        type: SET_DRAWER_STATE,
        payload: isOpen
    }
}


// WEBPACK FOOTER //
// ./src/actions/index.js